import { App, LoaderManager, LogwebAPI } from '@3cad/nextcore'
import {bus} from "@store/dau";
import {customImport} from "@/utils";
import {ProjectsAPI} from '@3cad/nextcore';
import {GeneralCadCmd} from '@3cad/nextcore'
import layedit from '@configurator/comp/mixins/layedit';
let lastConfigPage = null;

export default {
    mixins:[layedit],
    components: {
        mainlog: () => import("@main/mainlog.vue"),
        mainindex: () => import("@main/mainindex.vue"),
        pageHeader: () => customImport("comp/pageHeader.vue"),
        prjFinder: () => customImport("comp/prjFinder.vue"),
        prjFinderGallery: () => customImport("comp/prjFinderGallery.vue"),
        // Pages
        home: () => customImport("pages/home.vue"),
        startPrj: () => customImport("pages/startPrj.vue"),
        articleSearch: () => customImport("pages/articleSearch.vue"),
        compositions: () => customImport("pages/compositions.vue"),
        configure: () => customImport("pages/configure.vue"),
        view3d: () => customImport("pages/3dview.vue"),
        view2d: () => customImport("pages/2dview.vue"),
        renders: () => customImport("pages/renders.vue"),
        offer: () => customImport("pages/offer.vue"),
        prjSummary: () => customImport("pages/summary.vue"),
        prjLog: () => customImport("pages/prjLog.vue"),
        customerInfo: () => customImport("pages/customerInfo.vue"),
        notifications: () => customImport("pages/notifications.vue"),
        anonymize: () => customImport("pages/anonymize.vue"),
        delivery: () => customImport("erp/delivery.vue"),
        galleryRoles: () => customImport("erp/galleryRoles.vue"),
        promotions: () => customImport("pages/promotions.vue"),
        myProfile: () => customImport("pages/myProfile.vue")
    },
    data() {
        return {
            title: "CONFIGURATOR",
            /** Show/hide ask message before leave configurator page */
            askLeavePage: true,
            islogmode: false,
            routings: [],
            mode: 'home',
            laststate: {cod: 'offerview', key: 5},
            // Needed to be observable
            // gen: Dau.g,
            askend: false,
            isproject: true,
            mnuselect: 0,
            menu: require('@assets/next/json/menu.json'),
            showSettings: false,
            // Translation work fine if App is observable
            translator: App.translator,
            lockUndo: false
        };
    },
    computed: {
        paddingClass() {
            if (this.isIntoIframe) {
                return "no-menu";
            } else {
                switch (this.mode) {
                    case 'home':
                        return 'no-menu';
                    case 'startprj':
                    case 'projects':
                    case 'projects.guest':
                    case 'projects.my':
                    case 'projects.ext':
                    case 'projects.clinv':
                        return 'mid-menu';
                    default:
                        return 'full-menu';
                }
            }
        },
        preferences() {
            return this.$store.getters['getPreferences'];
        },
        user() {
            return this.$store.getters['getProfile']
        },
        prj() {
            return this.$store.state.project;
        },
        appLoading() {
            return this.$store.getters['loading'];
        },
        isUserLogin() {
            return (this.user && !this.user.guest) || this.guestUser;
        }
    },
    watch: {
        appLoading: function (obj) {
            if (obj.loading) {
                if (obj.message) {
                    this.$3cadLoader({body: obj.message, percentage: parseFloat(obj.percentage)});
                    // this.$refs.loaderMsg.open({ body: obj.message, percentage: parseFloat(obj.percentage) });
                } else {
                    this.$3cadFullLoader({percentage: parseFloat(obj.percentage)});
                    // this.$refs.loaderFull.open({ percentage: parseFloat(obj.percentage) });
                }
            } else {
                // this.$refs.loaderFull.close();
                // this.$refs.loaderMsg.close();
                this.$3cadFullLoader().close();
                this.$3cadLoader().close();
            }
        }
    },
    beforeCreate() {
        // Public variables and methods
        //disable window closing message if it's layedit.
        if(this.$isLayedit===false){
            window.onbeforeunload = () => {
                if (this.isUserLogin && this.askLeavePage) {
                    return this._trans("You have attempted to leave this page. Are you sure?");
                }
            };
        }
    },
    created() {
        //register layedit store module.
        if(this.$isLayedit){
            this.lay_registerStoreModule();
        }
        
        const sc = this;
        App.urHistory.setUndoLocked(this.lockUndo);
        this.$store.commit('cad/init');
        this.$store.commit('project/empty');
        this.load('.');
        // window.addEventListener('msgFromParent', this._messageFromParent);
        window.addEventListener('keydown', this._keydown);
        window.addEventListener('click', this._click);
        window.addEventListener('3cad:logout', this._logoutWithProject);

        bus.$on("route", e => {
            this.navigator = false;
            sc.routings.length = 0;
            sc.routings.push(e.cod);
            if (e.callback) e.callback();
            sc.$forceUpdate();
        });
        bus.$on("routeadd", e => {
            this.navigator = false;
            sc.routings.push(e.cod);
            sc.$forceUpdate();
        });
        bus.$on("routepop", id => {
            if (id >= 0 && id < sc.routings.length - 1) {
                sc.routings.splice(id + 1, sc.routings.length - 1 - id);
            }
        });
        bus.$on("startLoading", (message = null, percentage = null) => {
            this.$store.commit('startLoading', {msg: message, perc: percentage});
        });
        bus.$on("stopLoading", () => {
            this.$store.commit('resetLoading');
        });
        bus.$on("changeLang", () => {
            // this.translations = App.translator.getTranslations();
            this.$forceUpdate();
        });
        bus.$on('updateNotifications', () => {
            this.$store.dispatch('updateNotifications');
        });
        bus.$on('bv::modal::show', (e, modalId) => {
            let el = document.getElementById(modalId + '___BV_modal_body_');
            if (!!el) {
                el.addEventListener('contextmenu', this._preventContextOnModals)
            }
        });
        bus.$on('bv::modal::shown', (e, modalId) => {
            let el = document.getElementById(modalId);
            if (!!el) {
                el.addEventListener('contextmenu', this._preventContextOnModals)
            }
        });
        bus.$on('bv::modal::hide', (e, modalId) => {
            let el = document.getElementById(modalId);
            if (!!el) {
                el.removeEventListener('contextmenu', this._preventContextOnModals)
            }
        });
        document.addEventListener('contextmenu', (e) => {
            let el = e.target;

            if (el && el.classList.contains('modal-body'))
                this._preventContextOnModals(e)
        })

        // Check for RSA login
        // if(window.location.hash.indexOf('rsalogin') > -1){
        /*if(!this.$route && window.location.hash.indexOf('rsalogin') > -1){
            this.checkRSA();
        }*/
        let loader = new LoaderManager(
            msg => {
                bus.$emit('startLoading', msg);
            },
            (msg, perc) => {
                bus.$emit('startLoading', msg, perc);
            },
            () => {
                bus.$emit('stopLoading');
            }
        );

        // Function to check custom routing on created...
        this._checkRouting();

        App.setLoaderManager(loader);
    },
    mounted() {
        //begin layedit communication.
        if(this.$isLayedit){
            this.lay_startCommunication()
        }
        document.getElementsByTagName('body')[0].classList.remove("splash-screen");
        this._onAppMounted();
    },
    beforeDestroy() {
        bus.$off("route");
        bus.$off("routeadd");
        bus.$off("routepop");
        bus.$off("startLoading");
        bus.$off("stopLoading");
        bus.$off("changeLang");
        bus.$off("updateNotifications");
        bus.$off('bv::modal::shown');
        bus.$off('bv::modal::hide');
    },
    destroyed() {
        // window.removeEventListener('msgFromParent', this._messageFromParent);
        window.removeEventListener('keydown', this._keydown);
        window.removeEventListener('click', this._click);
        window.removeEventListener('3cad:logout', this._logoutWithProject);
    },
    methods: {
        _logoutWithProject() {
            this.$store.commit("project/empty");
        },
        _preventContextOnModals(e) {
            e.preventDefault();
        },
        _keydown(e) {
            // Open preferences for Windows
            if (e.ctrlKey && e.altKey && (e.key && e.key.toLowerCase() === 's')) {
                this.showSettings = true;
            }
        },
        _click(e) {
            bus.$emit('windowClick', e);
        },
        _checkRouting() {
        },
        _onAppMounted(){
        },
        _checkOldWalls() {
            return new Promise((resolve, reject) => {
                console.log('Has old walls', App.iCad.hasOldWalls())
                resolve()
            })
        },
        resetCustomerParams() {
        },
        /** Global new project
         */
        newPrj() {

            let initPrj = () => {

                if (localStorage['next_goto']) {
                    delete localStorage['next_goto'];
                }

                if (this.preferences.config.customerAssignment && !this.user.guest) {

                    this.$3cadComponent({
                        title: this._trans('Customer assignment'),
                        size: 'xl',
                        component: '_retrieveCustomer',
                        componentData: {},
                        componentEvents: ['select', 'skip']
                    }).then(({event, data}) => {
                        this.$store.commit('project/empty');
                        this.$store.commit('erp/reset');
                        this.resetCustomerParams();

                        //Empty breadcrumb store
                        if (this.$store.state.searchArticle)
                            this.$store.unregisterModule('searchArticle');

                        let customerData = data;
                        if (customerData) {
                            this.prj.customercod = customerData.email;

                            // Fill customer data
                            this.prj.orderaddress[0].email = customerData.email;
                            this.prj.orderaddress[0].firstname = customerData.firstName;
                            this.prj.orderaddress[0].surname = customerData.lastName;
                            this.prj.orderaddress[0].postalcode = customerData.postalCode;
                            this.prj.orderaddress[0].city = customerData.city;
                            this.prj.orderaddress[0].mobile = customerData.mobile;
                            this.prj.orderaddress[0].street = customerData.street;
                            this.prj.orderaddress[0].countrycode = customerData.country;
                        }

                        this.prj.isopen = true;
                        this.onNewProject();
                    });
                } else {
                    this.$store.commit('project/empty');
                    this.$store.commit('erp/reset');
                    this.resetCustomerParams();

                    //Empty breadcrumb store
                    if (this.$store.state.searchArticle)
                        this.$store.unregisterModule('searchArticle');

                    this.prj.isopen = true;
                    this.onNewProject();
                }
            };

            if (this.prj.isopen) {
                this.$3cadAsk({
                    title: this._trans('Project not saved'),
                    body: this._trans('Save current project?'),
                    okTitle: this._trans('Yes'),
                    cancelTitle: this._trans('No')
                }).then(data => {
                    this.savePrj().then(initPrj);
                }).catch(mode => {
                    if (mode === 0)
                        initPrj();
                });
            } else
                initPrj();
        },
        onNewProject(assignCustomer = false) {
            this.resetFiltraVariantiGraficheFiltersSaved();
            if (assignCustomer) {
                this.go("startprj");
            } else {
                this.go("startprj");
            }
        },
        /** Global open project
         * @param id
         */
        openPrj(id) {
            let loadPrj = () => {
                if (localStorage['next_goto']) {
                    delete localStorage['next_goto'];
                }
                bus.$emit('startLoading', this._trans('Loading project'));
                this.resetCustomerParams();
                this.$store.dispatch('project/load', {id: id}).then((prj) => {

                    this._checkOldWalls().then(() => {
                        this.pricesIncrease = prj.pricesIncrease;
                        if (this.$store.state.searchArticle)
                            this.$store.unregisterModule('searchArticle');
                        bus.$emit('stopLoading');
                        this.onProjectLoaded();
                    })
                }).catch(() => {
                    bus.$emit('stopLoading');
                });
            };

            if (this.prj.isopen) {
                this.$3cadAsk({
                    title: this._trans('Project not saved'),
                    body: this._trans('Save current project?'),
                    okTitle: this._trans('Yes'),
                    cancelTitle: this._trans('No')
                }).then(data => {
                    this.savePrj().then(loadPrj);
                }).catch(mode => {
                    if (mode === 0)
                        loadPrj()
                });
            } else {
                loadPrj()
            }
        },
        onProjectLoaded() {
            this.resetFiltraVariantiGraficheFiltersSaved();
            this.go('offerview');
        },
        /** Global save project
         * @returns {Promise}
         */
        async savePrj() {
            bus.$emit('startLoading', this._trans('Saving project'));

            // Add campaign description
            /*if(this.prj.campaign) {
                let campaigns = this.$store.getters['erp/campaigns'];
                let camp = campaigns.find( c => {
                    return c.cod === this.prj.campaign;
                });
                this.prj.campaignDes = camp.des || undefined;
            }*/

            if (this.preferences.config.saveprjpicture) {
                try {
                    this.prj.img = await this.$store.dispatch('cad/projectPicture', {prj: this.prj})
                } catch (e) {
                    console.error(e);
                }
            }

            return new Promise((resolve, reject) => {
                this.$store.dispatch('project/save', {}).then(res => {
                    this.$store.commit('resetLoading');
                    bus.$emit('savedPrj');
                    resolve();
                });
            });
        }, /** Global save project
         * @returns {Promise}
         */
        cloneProject() {
            bus.$emit('startLoading', this._trans('Cloning project'));
            return new Promise((resolve, reject) => {
                this.$store.dispatch('project/save', {clone: true}).then(res => {
                    this.$store.commit('resetLoading');
                    bus.$emit('savedPrj');
                    resolve();
                });
            });
        },
        deletePrj(id) {
            this.$3cadAsk({
                title: this._trans('Delete project'),
                body: this._trans('Would you like to delete this project?')
            }).then(data => {
                ProjectsAPI.deleteProject(id);
            });
        },
        /*checkRSA() {
            let params = window.location.hash.split('/');

            Dau.isRSALogin = true;
            Dau.RSAkey = params[params.length-1];

            Dau.trylogin(Dau.g.backsite, null, null, null, (res) => {
                    window.location.hash = '';
                    Dau.checklang();
                },
                (err) => {
                    console.log('Login fails', err);
                });
        },*/
        load(e) {
            if (this.prj.history.length === 0) {
                console.log(e);
                this.mode = 'home';
                this.mnuselect = 1
            } else {
                this.mode = this.laststate.cod;
                this.mnuselect = this.laststate.key;
            }
        },
        /** Navigation function for SPA Application
         * @param e - page to go
         * @param k - ?
         */
        go(e, k) {
            let pattern = /(configurator|[2,3]dview)/i;

            // Previous page
            if (/(configurator|[2,3]dview)/i.test(this.mode)) {
                lastConfigPage = this.mode;
                // App.urHistory.saveState( new ChangePageCmd(lastConfigPage, null, this) )
            }

            // Next page
            if (/(configurator|[2,3]dview)/i.test(e)/* && lastConfigPage && lastConfigPage !== e*/) {
                // Create undo
                // App.urit.push( new ChangePageCmd(e, lastConfigPage, this) );
                App.urHistory.saveState(new GeneralCadCmd(e, this, this.prj, App.iCad))
                //lastConfigPage = e;
            }

            // Save 2D environment before exit
            if (this.mode === '2dview') {
                this.$store.commit('cad/wallsToProject', this.prj);
            }
            if (e.cod === 'back') {
                this.mode = this.laststate.cod;
                this.mnuselect = this.laststate.key;
            } else {
                this.mnuselect = k;
                if (k > 0 && k < 8) {
//                  this.laststate.cod=e.cod;

                    this.laststate.cod = e.action;
                    this.laststate.key = k;
                }
//              this.mode=e.cod;
            }
            this.mode = e;

            // Instana monitoring
            if (window.ineum) {
                window.ineum("page", this.mode);
            }
            bus.$emit('changePage')
        },
        /*getmnudata(k) {
            let res=[];
            if (k === 0) {
                if (this.isproject) {
                    res.push ({cod:'back',des:'Back to Project'});
                    res.push ({des:'-'});
                }
                res.push({cod:'prjadd',des:'Add new Project'});
                res.push({cod:'prjmy',des:'My Projects'});
                if (Dau.g.seller>1) {
                    res.push({cod:'prjexisting',des:'existing projects'});
                    if (Dau.g.seller>=5) {
                        res.push({cod:'prjclosed',des:'closed/invalid'});
                    }
                }
            }
            else if (k === 8) {
                res.push({cod:'delivery',des:'deliveries'});
                res.push({cod:'promotions',des:'promotions'})
            }
            return res;
        },*/
        toggleLogsPanel() {
            this.showSettings = true;
        },
        unlockManteinance() {
            LogwebAPI.endMaintenance({}, (data) => {
                if(data.completed) {
                    this.$store.commit('setMantainance', {
                        isMaintenance: false
                    })
                }
            }, (err) => {
                console.error(err)
            })
        },
        lockManteinance() {
            LogwebAPI.startMaintenance({}, (data) => {
                this.$store.commit('setMantainance', {
                    isMaintenance: true
                })
                this.go('home')
            }, (err) => {
                console.error(err)
            })
        },
        cancelBookManteinance() {
            LogwebAPI.bookedMaintenanceSet({
                startDateTimeUTC: null,
                endDateTimeUTC: null,
            }, (data) => {
                this.$store.commit('setMantainance', {
                    isMaintenance: false
                })
            }, (err) => {
                console.error(err)
            })
        },
        resetFiltraVariantiGraficheFiltersSaved() {
            let savedKeys = Object.keys(sessionStorage).filter(key => key.indexOf("FILTRAVARIANTIGRAFICHE-") === 0);
            // console.log("savedKeys", savedKeys);
            savedKeys.forEach(key => {
                sessionStorage.removeItem(key);
            });
            // console.log("sessionStorage", Object.keys(sessionStorage));
        }
    }
};



// WEBPACK FOOTER //
// ./src/configurator/index.js